<style lang="less" scoped>
.container-div {
  margin: 20px 10px;
  font-size: 15px;
}
.title-div {
  font-weight: 800;
  margin: 10px 20px;
  font-size: 16px;
}
.cust-detail-div {
  line-height: 50px;
}
.cust-detail-title {
  text-align: right;
  margin-right: 100px;
  width: 150px;
}
.cust-detail-num {
  width: 80%;
  word-break: break-all;
}
.page-action-btns {
  margin-bottom: 10px;
}
.cust-mes {
  margin: 0px 0px 14px 18px;
}
.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}
.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}
.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
.header {
  display: flex;
  background: #81d3f8;
  border: 1px solid #000000;
  > div {
    width: 170px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-right: 1px solid #000000;
    &:nth-child(4) {
      border-right: 0;
    }
  }
}
.tabContent {
  border: 1px solid #000000;
  border-top: 0;
  border-bottom: 0;
  .tabContent-item {
    display: flex;
    > div {
      width: 170px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-bottom: 1px solid #000000;
      border-right: 1px solid #000000;
      &:nth-child(4) {
        border-right: 0;
      }
    }
  }
}
.noData {
  text-align: center;
  border: 1px solid #000000;
  border-top: 0;
  height: 40px;
  line-height: 40px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="客户信息" name="first">
            <div class="container-div">
              <div class="title-div">用户信息</div>
              <div class="cust-mes-div">
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">客户编号:</div>
                  <div>{{ detailForm.custNo }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">注册日期:</div>
                  <div>{{ detailForm.registerDate }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">首次充电:</div>
                  <div>{{ detailForm.firstChargeDate }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">手机号:</div>
                  <div v-if="mobileLength <= 11">{{ detailForm.mobile }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">openid:</div>
                  <div v-if="mobileLength > 11">{{ detailForm.openId }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">客户标签:</div>
                  <div>{{ detailForm.custTypeName }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">客户备注:</div>
                  <div v-if="remarkShow">{{ detailForm.remark }}</div>
                  <el-input
                    v-if="inputShow"
                    style="width: 200px"
                    size="small"
                    v-model="detailForm.remark"
                  ></el-input>
                  <el-button
                    v-if="btnShow"
                    type="primary"
                    size="small"
                    class="detail-btn"
                    @click="openInput"
                    >点击编辑</el-button
                  >
                  <el-button
                    v-if="editShow"
                    type="primary"
                    size="small"
                    class="detail-btn"
                    @click="toEdit()"
                    >编辑</el-button
                  >
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">客户运营商:</div>
                  <div>{{ detailForm.dealNames }}</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">公共充电桩IMEI号:</div>
                  <div class="cust-detail-num">
                    {{ detailForm.custPileCode }}
                  </div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">私人充电桩IMEI号:</div>
                  <div>{{ detailForm.privatePileCode }}</div>
                </div>
                <!-- <div class="flex cust-detail-div">
                                    <div class="cust-detail-title">微信免密:</div>
                                    <div>{{null}}</div>
                                </div> -->
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">桩到家剩余度电:</div>
                  <div>{{ detailForm.balanceValueZdj }}&nbsp;&nbsp;度电</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">服务商剩余度电:</div>
                  <div>{{ detailForm.balanceValue }}&nbsp;&nbsp;度电</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">余额:</div>
                  <div>{{ detailForm.balance }}&nbsp;&nbsp;元</div>
                </div>
              </div>
            </div>
            <div class="container-div">
              <div class="title-div">充电信息</div>
              <div class="cust-mes-div">
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">充电次数:</div>
                  <div>{{ detailForm.chargeCount }}&nbsp;&nbsp;次</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">充电量:</div>
                  <div>{{ detailForm.chargeVal }}&nbsp;&nbsp;kW·h</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">客户充电费用:</div>
                  <div>{{ detailForm.chargeFee }}&nbsp;&nbsp;元</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">平台抵扣电度:</div>
                  <div>{{ detailForm.chargeElecOnLine }}&nbsp;&nbsp;电度</div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">自营抵扣电度:</div>
                  <div>{{ detailForm.chargeElecOffLine }}&nbsp;&nbsp;电度</div>
                </div>
                <div class="flex">
                  <div class="cust-detail-title">消费过的电站:</div>
                  <div class="cust-detail-num">
                    {{ detailForm.stationNames }}
                  </div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title">开票信息</div>
                  <div class="">
                    <p>
                      近一年可开票金额<span style="color: red">{{
                        detailForm.surplusInvoicableAmount
                      }}</span
                      >元
                    </p>
                    <div class="flex">
                      <div v-if="invoicingShow">
                        历史可开票金额
                        <span style="color: red">{{
                          detailForm.historicalInvoicableAmount
                        }}</span>
                        元，线下已开金额
                        <span style="color: red">{{
                          detailForm.alreadyInvoicableAmount
                        }}</span>
                        元
                      </div>
                      <div v-else>
                        可开票金额
                        <span style="color: red">{{
                          detailForm.surplusInvoicableAmount
                        }}</span>
                        元，本次开票
                        <el-input-number
                          v-model="invoicedAmount"
                          controls-position="right"
                          :min="0"
                          :max="detailForm.surplusInvoicableAmount"
                          size="mini"
                          :precision="2"
                        ></el-input-number>
                        &nbsp;&nbsp;元
                      </div>
                      <div>
                        <el-button
                          type="primary"
                          size="small"
                          class="detail-btn"
                          v-if="invoicingShow"
                          @click="showInvoicing"
                          >新增线下开票</el-button
                        >
                        <el-button
                          type="primary"
                          size="small"
                          class="detail-btn"
                          v-else
                          @click="addInvoicing"
                          >提交</el-button
                        >
                        <el-button
                          type="primary"
                          size="small"
                          class="detail-btn"
                          @click="seeInvoicingDetail"
                          >线下开票记录</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex cust-detail-div">
                  <div class="cust-detail-title"></div>
                  <div v-if="detailShow">
                    <div class="header">
                      <div>可开票金额</div>
                      <div>已开金额</div>
                      <div>开票金额</div>
                      <div>变更时间</div>
                    </div>
                    <div class="noData" v-if="noData">暂无开票记录</div>
                    <div class="tabContent" v-else>
                      <div
                        class="tabContent-item"
                        v-for="item in invoicedList"
                        :key="item.invoicingId"
                      >
                        <div>{{ item.surplusInvoicableAmount }}</div>
                        <div>{{ item.alreadyInvoicableAmount }}</div>
                        <div>{{ item.invoicableAmount }}</div>
                        <div>{{ item.lastModifiedWhen }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="运营商充值记录" name="second">
                            <div class="page-action-btns flex">
                                <button class="common-bg-button" @click="handleCustRecharge('1')">充值</button>
                                <button class="common-bg-button" @click="handleCustRecharge('2')">退款</button>
                            </div>
                            表格
                            <div class="list-table">
                                <ZD-table :tableColumns="pageConfig.custDetailColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
                            </div>
                            分页
                            <div class="list-pagination">
                                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
                            </div>
                            <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="35%">
                                <div class="cust-mes">客户手机：{{detailForm.mobile}}</div>
                                <div class="cust-mes">客户备注：{{detailForm.custRemark}}</div>
                                <div class="cust-mes">最近充值：{{recentInTime}}</div>
                                <div class="cust-mes">当前余额：{{actInExpAmount}}</div>
                                <el-form :model="dialogForm" label-width="100px" ref="dialogForm" :rules="pageConfig.selectFormRules">
                                    <el-form-item :label="dialogLabel" prop="inExpAmount">
                                        <el-input style="width:320px;" size="small" v-model="dialogForm.inExpAmount" autocomplete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="备注" prop="remark">
                                        <el-input style="width:320px;" size="small" v-model="dialogForm.remark" autocomplete="off"></el-input>
                                    </el-form-item>
                                </el-form>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                                    <el-button type="primary" size="small" @click="handleCustBehavior('dialogForm')">确 定</el-button>
                                </div>
                            </el-dialog>
                        </el-tab-pane> -->
          <el-tab-pane label="桩到家度电设置" name="third">
            <div class="page-action-btns flex">
              <button
                class="common-bg-button"
                @click="handleSetkWh"
                v-if="$S.checkUserMenu('CUST_CHARGE_ELEC_ADD')"
              >
                设置
              </button>
              <div class="top-title-div">
                <div>当前剩余度电：{{ chargeBalanceValue || 0 }}度电</div>
                <div>累计度电：{{ totalChargeValue || 0 }}度电</div>
              </div>
              <!-- <button class="common-bg-button" @click="handleCustRecharge('2')">退款</button> -->
            </div>
            <!-- 表格 -->
            <div class="list-table">
              <ZD-table
                :tableColumns="pageConfig.custkWhDetailColumns"
                :operates="operates"
                :tableData="chargeData"
                :tableConfig="pageConfig.tableConfig"
                :selections="selections"
                v-on:updateSelections="
                  (sels) => {
                    selections = sels;
                  }
                "
              ></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
              <ZD-pagination
                :pagination="pagination"
                v-on:pageUpdate="getTableData"
              ></ZD-pagination>
            </div>
            <el-dialog
              title="设置"
              :visible.sync="thirdDialogFormVisible"
              width="35%"
            >
              <el-form
                :model="dialogForm"
                label-width="100px"
                ref="dialogForm"
                :rules="pageConfig.selectFormRules"
              >
                <el-form-item label="桩到家度电" prop="chargeValue">
                  <!-- <el-input style="width:320px;" size="small" v-model="dialogForm.chargeValue" @input="changeRefund" placeholder="正数充值，负数退款"></el-input><span style="padding-left: 10px">度电</span> -->
                  <el-input-number
                    style="width: 320px"
                    v-model="dialogForm.chargeValue"
                    @change="changeRefund"
                    :precision="2"
                    :min="-999999.99"
                    :max="999999.99"
                    label="描述文字"
                    :controls="false"
                    size="small"
                    :step="0.1"
                  ></el-input-number
                  ><span style="padding-left: 10px">度电</span>
                </el-form-item>
                <div class="red-tip" v-if="tipFlag">
                  退款度电不得超过剩余度电
                </div>
                <el-form-item label="备注" prop="remark">
                  <el-input
                    style="width: 320px"
                    size="small"
                    v-model="dialogForm.remark"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="thirdDialogFormVisible = false" size="small"
                  >取 消</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="handleCustBehavior('dialogForm')"
                  :disabled="btnUse"
                  >确 定</el-button
                >
              </div>
            </el-dialog>
            <el-dialog
              title="备注"
              :visible.sync="remarkDialogFormVisible"
              width="35%"
            >
              <el-form
                :model="dialogRemarkForm"
                label-width="100px"
                ref="dialogRemarkForm"
                :rules="pageConfig.remarkFormRules"
              >
                <el-form-item label="备注" prop="remark">
                  <el-input
                    style="width: 320px"
                    size="small"
                    v-model="dialogRemarkForm.remark"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="remarkDialogFormVisible = false" size="small"
                  >取 消</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="handleRemarkBehavior('dialogRemarkForm')"
                  :disabled="btnUse"
                  >确 定</el-button
                >
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="订单流水" name="fourth"> </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      chargeData: [],
      selections: [], // 表格选项
      pagination: pageConfig.detailPagination,
      pageConfig,
      editFlag: false,
      pageTitle: "客户详情",
      // 默认值设置
      detailForm: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: "",
        chargeValue: "",
      },
      activeName: "first", //默认激活状态
      operates: {
        width: 220,
        fixed: "right",
        list: [
          {
            id: "remark",
            label: "备注",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRemark(row);
            },
          },
        ],
      }, // 列操作按钮
      dialogFormVisible: false, //未使用(已删除功能)
      thirdDialogFormVisible: false, //度电设置弹窗
      dialogTitle: "", //未使用(已删除功能)
      dialogLabel: "", //未使用(已删除功能)
      actInExpAmount: "", //未使用(已删除功能)
      recentInTime: "暂无充值记录", //未使用(已删除功能)
      totalChargeValue: "", //累计度电
      chargeBalanceValue: "", //剩余度电
      tipFlag: false, //度电设置弹窗错误提示语
      btnUse: false, //判断是否可以点击确定按钮
      remarkShow: true, //客户备注内容是否显示
      inputShow: false, //备注内容输入框
      btnShow: true, //备注内容编辑按钮
      editShow: false, //备注内容保存按钮
      remarkDialogFormVisible: false, //备注信息弹窗
      dialogRemarkForm: {
        //备注信息表单内容
        remark: "",
      },
      mobileLength: "", //手机号码位数
      invoicingShow: true,
      detailShow: false,
      invoicedAmount: 0, //开票金额
      noData: false,
      invoicedList: [], //开票记录
    };
  },
  methods: {
    init() {
      if (this.$store.state.editId) {
        this.editFlag = true;
        this.getFormInfo();
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this;
      _.$H
        .post(_, _.$A.cust.cust, {
          custId: _.$store.state.editId,
        })
        .then((res) => {
          _.detailForm = res.data.data;
          _.custDto = res.data.data.custDto;
          _.mobileLength = _.detailForm.mobile.length;
        });
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.get(_, _.$A.cust.custwalletlist, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 获取表格数据
    getTableData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.userCustNo = _.detailForm.custNo;
      _.queryInfo.dealerNo = _.$store.state.userInfo.dealNo;
      _.queryInfo.chargeType = "02";
      _.$H.get(_, _.$A.cust.chargeCardList, _.queryInfo).then((res) => {
        //_.chargeData = res.data.data.chargeCardListEntities.content || [];
        _.chargeData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
        if (_.chargeData) {
          _.dialogForm.cardNo = _.chargeData[0].cardNo;
          _.chargeBalanceValue = _.chargeData[0].totalChargeBalanceValue;
          _.totalChargeValue = _.chargeData[0].totalChargeValue;
        }
        // _.chargeBalanceValue = res.data.data.chargeBalanceValue;
        // _.totalChargeValue = res.data.data.totalChargeValue;
      });
    },
    // 获取表格数据
    // getTableData(pagination, reload = false) {
    //     let _ = this;
    //     _.$U.showLoading(_);
    //     _.queryInfo.pageNum = pagination.current - 1;
    //     if (reload) {
    //         _.queryInfo.pageNum = 0;
    //     }
    //     _.queryInfo.pageSize = pagination.pageSize;
    //     _.queryInfo.corpNo = _.$store.state.corpNo;
    //     _.$H.get(_, _.$A.cust.custwalletlist, _.queryInfo).then(res => {
    //         _.tableData = res.data.data.content || [];
    //         _.pagination.total = res.data.data.totalElements || 0;
    //         _.$U.hideLoading(_);
    //     })
    // },
    //导航栏切换
    handleClick(tab, event) {
      this.queryInfo.custNo = this.detailForm.custNo;
      if (tab.index == 1) {
        this.getTableData(this.pagination);
      } else if (tab.index == 2) {
        let _ = this;
        var url = _.$router.resolve({
          name: "orderManageList",
          query: {
            mobile: _.detailForm.mobile,
          },
        });
        window.open(url.href, "_blank");
      } else {
        this.init();
      }
    },
    //该功能已注销
    handleCustRecharge(type) {
      let _ = this;
      if (_.tableData.length > 0) {
        _.actInExpAmount = _.tableData[0].changeFreeBal;
        _.recentInTime = _.tableData[0].recentInTime;
      } else {
        _.actInExpAmount = 0;
      }
      _.dialogForm = {};
      this.dialogFormVisible = true;
      if (type == "1") {
        _.dialogTitle = "客户充值";
        _.dialogLabel = "充值（元）";
      } else {
        _.dialogTitle = "客户退款";
        _.dialogLabel = "退款（元）";
      }
    },
    //度电设置
    handleCustBehavior(formName) {
      let _ = this;
      // var strTemp = /^(-)?\d+(\.\d+)?$/;
      // if (strTemp.test(_.dialogForm.chargeValue)) {
      // }else{
      //     _.$U.error('请输入数字');
      //     return false;
      // }
      if (
        Number(_.dialogForm.chargeValue) < 0 &&
        Number(_.dialogForm.chargeValue) + Number(_.chargeBalanceValue) < 0
      ) {
        _.$U.error("操作失败");
        return;
      }
      _.dialogForm.userCustNo = _.detailForm.custNo;
      _.dialogForm.lastModifiedByName =
        _.$store.state.userInfo.lastModifiedByName;
      _.dialogForm.dealNo = _.$store.state.userInfo.dealNo;
      _.dialogForm.dealerNo = _.$store.state.userInfo.dealNo;
      _.dialogForm.useredPhone = _.detailForm.mobile;
      //_.dialogForm.custNo = _.detailForm.custNo;
      //_.dialogForm.transactionChannel = '06';
      // if(_.dialogLabel == '充值（元）'){
      //     _.dialogForm.operateType = '01';
      // }else if(_.dialogLabel == '退款（元）'){
      //     _.dialogForm.operateType = '07';
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H.post(_, _.$A.cust.addCardList, _.dialogForm).then((res) => {
            _.$U.success("操作成功");
            _.thirdDialogFormVisible = false;
            _.getTableData(_.pagination);
            _.$U.hideLoading(_);
          });
        }
      });
    },
    //编辑备注
    openRemark(val) {
      this.remarkDialogFormVisible = true;
      this.dialogRemarkForm.chargeCardId = val.chargeCardId;
      this.dialogRemarkForm.remark = "";
    },
    //保存备注
    handleRemarkBehavior(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H
            .post(_, _.$A.cust.editCardList, _.dialogRemarkForm)
            .then((res) => {
              _.$U.success("操作成功");
              _.remarkDialogFormVisible = false;
              _.getTableData(_.pagination);
              _.$U.hideLoading(_);
            });
        }
      });
    },
    //度电设置输入框 限制数字
    changeRefund() {
      let _ = this,
        chargeValue = _.dialogForm.chargeValue;
      if (
        Number(chargeValue) < 0 &&
        Number(chargeValue) + Number(_.chargeBalanceValue) < 0
      ) {
        _.tipFlag = true;
        _.btnUse = true;
      } else {
        _.tipFlag = false;
        _.btnUse = false;
      }
    },
    //打开设置弹窗
    handleSetkWh() {
      this.dialogForm = {};
      this.tipFlag = false;
      this.thirdDialogFormVisible = true;
    },
    //点击编辑
    openInput() {
      this.btnShow = false;
      this.editShow = true;
      this.remarkShow = false;
      this.inputShow = true;
      //this.detailForm.remark = '';
    },
    //保存编辑内容
    toEdit() {
      let _ = this;
      _.$U.showLoading(_);
      var obj = {};
      obj.lastModifiedByName = _.$store.state.userInfo.lastModifiedByName;
      obj.id = _.$store.state.editId;
      obj.remark = _.detailForm.remark;
      obj.mobile = _.detailForm.mobile;
      obj.custNo = _.detailForm.custNo;
      obj.custType = _.detailForm.custType;
      obj.editParam = "custRemark";
      _.$H.post(_, _.$A.cust.targetremark, obj).then((res) => {
        _.$U.success("编辑成功");
        _.btnShow = true;
        _.editShow = false;
        _.remarkShow = true;
        _.inputShow = false;
        _.getFormInfo();
        _.$U.hideLoading(_);
      });
    },
    showInvoicing() {
      this.invoicingShow = false;
    },
    /**新增开票接口 */
    addInvoicing() {
      let _ = this;
      console.log(this.invoicedAmount);
      if (this.invoicedAmount == 0) {
        _.$U.error("开票金额不能为0");
        return false;
      }
      _.$H
        .post(_, _.$A.cust.addInvoicing, {
          corpNo: "CO1524100773815",
          dealerNo: "DEAL1543895439624",
          custPhone: _.detailForm.mobile,
          invoicableAmount: _.invoicedAmount,
        })
        .then((res) => {
          _.$U.success("开票成功");
        });
    },
    /**查询开票记录 */
    seeInvoicingDetail() {
      let _ = this;
      _.$H
        .post(_, _.$A.cust.getInvoicingList, {
          corpNo: "CO1524100773815",
          dealerNo: "DEAL1543895439624",
          custPhone: _.detailForm.mobile,
        })
        .then((res) => {
          this.detailShow = true;
          console.log(res.data.data.content);
          _.invoicedList = res.data.data.content || [];
          if (_.invoicedList.length == 0) {
            _.noData = true;
          }
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
